
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.353 14.574v-2.599h3.293v2.599L8.001 16zM1.424 9.647L0 8.002l1.424-1.648h2.6v3.293zm.762 1.838l1.838-1.838 2.329 2.328-1.837 1.837-2.174-.157zm2.329-9.297l1.838 1.837-2.329 2.329-1.837-1.837.156-2.174zm5.133-.762v2.599H6.353V1.426L7.999 0zm4.927 8.221h-2.599V6.354h2.599L16 7.999zm-.761-5.13l-1.838 1.837-2.328-2.329 1.836-1.837 2.174.157zm-2.33 9.295l-1.836-1.837 2.326-2.329 1.84 1.839-.156 2.172z"}})])
          )
        }
      }
    